import { Box, Button, Checkbox, CircularProgress, FormGroup, Grid, Paper, TextField, Tooltip, Typography } from "@mui/material";
import { Edit } from '@mui/icons-material';
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { globalGetService, globalPutService } from "../../../../utils/globalApiServices";
import { checkApiStatus } from "../../../../utils";
import { PageLoader } from "../../../../shared_elements";
import { enqueueSnackbar } from "notistack";
import { getWetLeaseCardDetailApi, updateWetLeaseCardDetailApi } from "../apiService";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";
const WetLeaseCardRU = () => {
    const { leaseSlug } = useParams();
    const params = { leaseSlug };
    const [isLoading, setLoading] = useState(false);
    const [wetLeaseCardInfo, setWetLeaseCardInfo] = useState({});
    const [prevData, setPrevData] = useState({});
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        getWetLeaseCardData();
        trackActivity('Page Viewed', { page_title: 'Wet Lease Config' })
    }, [])

    const getWetLeaseCardData = (loaderType, query = {}) => {
        setLoading(true);
        globalGetService(getWetLeaseCardDetailApi(params)).then(response => {
            if (checkApiStatus(response)) {
                setWetLeaseCardInfo(response?.data?.data);
            }
            setLoading(false);
        })
    }
    const editWetLeaseCardData = () => {
        setLoading(true);
        globalPutService(updateWetLeaseCardDetailApi(params), wetLeaseCardInfo).then(response => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                trackActivity('Item Edited', { page_title: `Edit Wet Lease Config`, success_msg: response?.data?.message, lease_id: wetLeaseCardInfo?.lease, payload: wetLeaseCardInfo, response: response?.data })
                setEditMode(false);
            }
            setLoading(false);
        })
    }


    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Wet Lease Config`, page_type: page_type, })
    }
    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    padding: 1,
                    borderRadius: 2,
                    margin: '10px 1px 8px 1px',
                    boxShadow: "0px 0px 3px 1px #BBBBBB"
                }}
            >
                <Grid sx={{ display: 'flex', justifyContent: "end", alignItems: 'center' }} mb={2}>
                    <Grid>
                        <ul className="list-inline" style={{ float: "right", alignItems: "center", display: "flex" }}>
                            <li>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "wet_lease", operationType: ['U'] }}>
                                    {!editMode &&
                                        <Tooltip title="Edit">
                                            <Edit fontSize="small" color="primary" sx={{ cursor: 'pointer' }}
                                                onClick={() => { setEditMode(true); setPrevData(wetLeaseCardInfo); handleItemClicked('Wet Lease Config EditIcon') }} />
                                        </Tooltip>}
                                </PermissionWrapper>
                            </li>
                        </ul>
                    </Grid>
                </Grid>
                <Grid container spacing={{ xs: 0, md: 2 }}>
                    {editMode ?
                        <Grid size={{ md: 12, xs: 12 }} sx={{ backgroundColor: '#FFFFFF' }}>
                            <TextField
                                id="wetlease_comments"
                                value={wetLeaseCardInfo?.wetlease_comments || ''}
                                label="Wet Lease Comment"
                                variant="outlined"
                                onChange={(e) => setWetLeaseCardInfo(prev => ({ ...prev, wetlease_comments: e.target.value }))}
                                size="small"
                                margin="normal"
                                fullWidth
                                multiline
                                rows={3}
                                slotProps={{ inputLabel: { shrink: true } }}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                disabled={!editMode}
                            />
                        </Grid>
                        : <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Wet Lease Comment' value={wetLeaseCardInfo?.wetlease_comments || ""} />
                        </Grid>}
                    <Grid size={{ md: 4, xs: 12 }}>
                        <FormGroup className='disabled-checkbox-wrapper'>
                            <Box className="check-item-div" sx={{cursor: !editMode ? 'not-allowed' : 'pointer'}}>
                                <Checkbox checked={wetLeaseCardInfo?.right_to_wetlease_without_prior_approval === true ? true : false} onChange={(e) => setWetLeaseCardInfo(prev => ({ ...prev, right_to_wetlease_without_prior_approval: e.target.checked }))} disabled={!editMode} />
                                <Typography className="check-item-span" fontSize='14px'>Right to Wet Lease without prior Approval</Typography>
                            </Box>
                        </FormGroup>
                    </Grid>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <FormGroup className='disabled-checkbox-wrapper' >
                            <Box className="check-item-div" sx={{cursor: !editMode ? 'not-allowed' : 'pointer'}}>
                                <Checkbox checked={wetLeaseCardInfo?.wetlease_fee === true ? true : false} onChange={(e) => setWetLeaseCardInfo(prev => ({ ...prev, wetlease_fee: e.target.checked }))} disabled={!editMode} />
                                <Typography className="check-item-span" fontSize='14px'>Wet Lease Fee</Typography>
                            </Box>
                        </FormGroup>
                    </Grid>

                </Grid>
                {editMode && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', py: '6px', }}>
                        <Button className='cancel-btn' onClick={() => { setEditMode(false); setWetLeaseCardInfo(prevData); handleItemClicked('Cancel Button') }} sx={{ mr: 1 }} variant="outlined" size="small" disabled={isLoading}>
                            Cancel
                        </Button>
                        <Button className='btn-primary' onClick={() => { handleItemClicked('Save Button'); editWetLeaseCardData(); }} variant="contained" size="small">
                            {isLoading ? <CircularProgress color='inherit' size={24} /> : 'Save'}
                        </Button>
                    </Box>
                )}
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default WetLeaseCardRU;